var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);

const setLoadingState = async (elements, isLoading) => {
    if (isLoading) {
        elements.forEach(element => {
            element.classList.add('shimmer');
        })
    } else {
        elements.forEach(element => {
            element.classList.remove('shimmer');
        })
    }
}
const addToCart = (body, reload = true, autoclose = false, showToast = false) => updateCart('add', body, reload, autoclose, showToast);
const changeCart = (body, reload = true, autoclose = false, showToast = false) =>
    updateCart('add', body, reload, autoclose, showToast);
const updateCart = async (type, body, reload = true, autoclose = false, showToast = false) => {
    const url =
        type === 'add'
            ? window.themeVariables.routes.cartAddUrl
            : window.themeVariables.routes.cartChangeUrl;

    let sectionsToBundle = new Set();
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));

    body.sections = [...sectionsToBundle].join(",");
    body.sections_url = window.location.pathname;

    const response = await fetch(`${url}.js`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
    });

    if (!response.ok) {
        let errorMessage = `HTTP error! status: ${response.status}`;
        try {
            const errorData = await response.json();
            if (errorData?.message) {
                errorMessage = errorData.message;
            }
        } catch {
            // Ignore JSON parsing errors; fall back to generic message
        }
        throw new Error(errorMessage);
    }

    const cartContent = await response.json();
    const productTitle = cartContent?.product_title || 'product';

    if (showToast && window.themeVariables.settings.cartType === 'message') {
        const toastEvent = new CustomEvent('toast:show', {
            detail: {
                message: window.themeVariables.strings.addedToCart.replace('{{product_title}}', productTitle),
                tone: 'success',
                duration: 2500
            }
        });
        document.dispatchEvent(toastEvent);
    }

    if (reload) {
        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
                baseEvent: "variant:add",
                cart: cartContent
            }
        }));

        if (autoclose) {
            setTimeout(() => {
                document.documentElement.dispatchEvent(new CustomEvent('multidrawer:close'));
            }, 3000);
        }

        if (window.location.pathname === '/cart') {
            window.location.reload();
        }
    }
};



const reloadMiniCart = (cartContent, autoclose) => {
    // This function is kept for backwards compatibility, but the logic is now in updateCart
};

document.addEventListener("variant:change", function (e) {
    // Get all variant swatches
    const swatches = document.querySelectorAll(".block-swatch");
    const variantValue = e.detail.variant.option1;

    swatches.forEach(swatch => {
        const swatchValue = swatch.textContent.trim();
        if (swatchValue === variantValue) {
            swatch.classList.add("block-swatch--selected");
        } else {
            swatch.classList.remove("block-swatch--selected");
        }
    });
});




/*
(function () {
    // Store the original dispatchEvent method
    const originalDispatchEvent = EventTarget.prototype.dispatchEvent;

    // Override the dispatchEvent method
    EventTarget.prototype.dispatchEvent = function (event) {
        console.log(`Event dispatched: ${event.type}`, {
            event: event,
            element: this
        });
        originalDispatchEvent.call(this, event);
    };
})();
*/

// Scroll to materials container when clicking badge
document.addEventListener('click', function (e) {
    const badge = e.target.closest('.product-info-extra .badge');
    if (!badge) return;

    const target = document.querySelector('.materials__container');
    if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
});
